const apiBaseUrl = process.env.REACT_APP_API_URL;
if (!apiBaseUrl) {
  throw new Error('REACT_APP_API_URL is required at build time');
}

export const getApiEndpoint = (path: string): string => {
  return `${apiBaseUrl}${path}`;
};
